import clsx from "clsx";
import { forwardRef, InputHTMLAttributes } from "react";

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  asChild?: boolean;
  type?: "text" | "email" | "password" | "number" | "search";
};

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", ...props }, ref) => {
    return (
      <input type={type} ref={ref} className={clsx(className)} {...props} />
    );
  },
);

Input.displayName = "Input";
